import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import no from "locales/no.json"

const resources = {
  no: {
    translation: no
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    lng: "no",
    interpolation: {
      escapeValue: false
    }
  })

  export default i18n
